<div [ngClass]="{'bg-img': !isSmallScreen}" class="mb-30 d-flex justify-content-center">
  @if (!isLoading && calendarProduct) {
      <div style="max-width: 900px;" class="p-0" [ngClass]="isCustom ? 'custom-container' : 'container'">
        <div class="d-flex justify-content-between" [ngClass]="{'flex-reverse' : isSmallScreen,'pt-50' : !isSmallScreen,'clipped-bg-grey' : isSmallScreen && calendarProduct?.image}">
          <div class="d-flex flex-column justify-content-between p-0" [ngClass]="{'h-330' : !isSmallScreen }">
            <div [ngClass]="{'mt-20' : !isSmallScreen, 'flex-column align-items-center mt-20': isSmallScreen }">
               @if(isSmallScreen){
                <div class="share-button" style="width: fit-content;margin: 0;" (click)="onShareEvent()"> <span class="material-symbols-outlined fz-16 mr-5 color-white"> share </span> <span class="fz-14 color-white"> {{ 'general.share' | translate }} </span></div>
              }
              <h2 class="calendar-product-title pb-10">{{ calendarProduct.title }}</h2>
              @if(!isSmallScreen){
                <div class="social-share mt-20 mb-50">
                  <app-social-share></app-social-share>
                </div>
              }
            </div>
            <div>
             
              <div class="d-flex mb-25 location-container">
                <div class="location-icon location-icon-custom"> </div>
                <div class="location-text" [ngClass]="{'text-center' : isSmallScreen}">
                  {{ calendarProduct.location }}
                </div>
              </div>
              <div class="d-flex mb-25 location-container">
                <div> <img alt="round" class="mr-22" src="assets/images/icon/svg/map.svg"> </div>
                <div class="location-text" [ngClass]="{'text-center' : isSmallScreen}">
                  {{'selling.from' | translate}} {{ calendarProduct.firstAvailableDate | localizedDate }}
                </div>
              </div>
            </div>
                                  
          </div>
          @if (calendarProduct?.image) {
            <div class="px-0 px-sm-15" [ngClass]="isSmallScreen && allDataLoadeded ? ['clipped-bg-grey', 'clipped-bg-small'] : []">
              <img [src]="calendarProduct.image" imageLoader (loadError)="showImage = false" thumbnailSize="L" class="fade-in product-image mt-0 mt-sm-5">
            </div>
          }
        </div>
        @if(!isSmallScreen){
          <div class="fz-22 mt-30 mb-10">
            {{ 'general.select_your_date' | translate }}
          </div>
        }
        <div class="custom-calendar-border"><app-calendar-view [calendarEvent]="calendarProduct" [isLoading]="isLoading"></app-calendar-view></div>
      </div>
  }
</div>
<!-- <app-loading-overlay [showLoading]="isLoading"></app-loading-overlay> -->